import {
  amex,
  cb,
  discover,
  diners,
  jcb,
  laser,
  maestro,
  mastercard,
  wex,
  switchCard,
  visa,
  rupay,
  carnet,
  privateLabel,
  prosa,
  unknown,
  pulse,
  interlink,
  affn,
  culiance,
  accel,
  star,
  nyce,
  conduent,
  bancnet,
  shazam,
  solutran,
  inmar,
  cu24,
  interac,
  quest,
  ebt,
  evo,
  electron
} from '../CardTypes';

const cardGraphics = {
  AX: amex,
  CBRT: cb,
  DI: discover,
  DC: diners,
  JCB: jcb,
  LASE: laser,
  MC: mastercard,
  WX: wex,
  MES: maestro,
  SWI: switchCard,
  VI: visa,
  RP: rupay,
  CN: carnet,
  PL: privateLabel,
  PR: prosa,
  UN: unknown,
  PU: pulse,
  INTRL:interlink,
  AF: affn,
  CL: culiance,
  AC: accel,
  ST: star,
  NY: nyce,
  CO: conduent,
  BN: bancnet,
  SH: shazam,
  SO: solutran,
  IN: inmar,
  MS: maestro,
  CU: cu24,
  QU: quest,
  INTRC: interac,
  EBT: ebt,
  EV: evo,
  EL: electron
};

export default cardGraphics;
